import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogTitle: {
    paddingRight: theme.spacing(8),
  },
}));

const SLACK_TEAM_ID = 'T035UPT3CJC';
const DEVIN_BOT_USER_ID = 'U0B68DGC47Q';
const DEVIN_MARKETPLACE_URL =
  'https://spin.devinenterprise.com/settings/connections';

interface DevinChatDialogProps {
  open: boolean;
  onClose: () => void;
}

export const DevinChatDialog = ({ open, onClose }: DevinChatDialogProps) => {
  const classes = useStyles();

  const handleOpenChat = () => {
    const slackDeepLink = `slack://user?team=${SLACK_TEAM_ID}&id=${DEVIN_BOT_USER_ID}`;
    window.location.href = slackDeepLink;
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>
        ¿Tienes dudas? Devin tiene respuestas
        <IconButton
          aria-label="cerrar"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Para hacer una pregunta al bot, inicia tu mensaje con:
        </Typography>
        <Typography variant="body1" component="div" style={{ marginTop: 12 }}>
          • <strong>!ask</strong> tu-duda - Para preguntas generales
          <br />• <strong>!deep</strong> tu-duda - Para análisis profundos
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOpenChat} color="primary" variant="contained">
          Abrir chat en Slack
        </Button>
      </DialogActions>
    </Dialog>
  );
};
